
import React, { Component } from 'react';
import '../Text/text.css'
import {serverUrl} from '../../../utils/restUtils'
import { Editor } from '@tinymce/tinymce-react';
import { change } from 'redux-form';
class Text  extends Component{

    
    render() {

	const { input, label, type, icon, unit, meta: { dispatch, form, touched, error } } = this.props
	
	const setValue = (text) => {	
	    dispatch(change(form, input.name, text))
	}

	return (
	    
	    <div className={['electroInput', ((error) ? 'error' : ''), ((input.value) ? 'touched' : '')].join(" ")} >
		<div>
		    
		    <label>
			{label}
			<span className="errorLabel"> - {error}</span>
		    </label>
		    
		    <textarea {...input} autoComplete="off" placeholder={label} style={{display: 'none'}} />
		    <div style={{height: '1px'}}></div>
		    <div className="textarea">
			<Editor
			ref="editor"
			    id="my_textarea_id"
			    value={input.value}
			init={{
			    height : "350",
			    plugins: 'link image code table textcolor',
			    statusbar: false,
			    
			    menubar:false,
			    toolbar: 'fontselect | undo redo  | bold italic underline strikethrough | alignleft aligncenter alignright |  fontsizeselect forecolor backcolor | bullist numlist outdent indent | link | table | image',
			    images_upload_url: serverUrl()+'/images',
			    images_upload_base_path: '/',
			    images_upload_credentials: true,
			    content_style: 'body { font-family: Roboto,sans-serif; }',
			    font_formats: "Default=Roboto,sans-serif;"
			}}
			    onEditorChange={setValue}
			/></div>
			
		</div>
	    </div>
	)
    }
}

export default Text



// WEBPACK FOOTER //
// ./src/components/Inputs/Textarea/Textarea.jsx